<template>
    <div class="x_box A4">
        <div class="x_body">
            <div class="print-header">
                <h2 class="text-center" style="font-weight: bold;">{{company.Name}}</h2>
                <h4 class="text-center font-m">{{$t('stock_out_detail')}}</h4>
                <p class="text-center">{{fromd}} ដល់ {{tod}}</p>
            </div>
            <table class="table table-bordered table-striped table-sm no-bor">
                <thead>
                    <tr>
                        <th>{{ $t('no') }}</th>
                        <th>{{ $t('date') }}</th>
                        <th>{{ $t('stock_in_no') }}</th>
                        <th>{{ $t('barcode') }}</th>
                        <th>{{ $t('name') }}</th>
                        <th>{{ $t('location')}}</th>
                        <th class="text-right">{{ $t('qty')}}</th>
                        <th class="text-right">{{ $t('qty_in') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(ret, index) in records" :key="index">
                        <td>{{index+1}}</td>
                        <td>{{$format(ret.DateApproved,'DD/MM/YYYY')}}</td>
                        <td>{{ ret.InvoiceNo }}</td>
                        <td>{{ret.ItemCode}}</td>
                        <td>{{ret.ItemName}}</td>
                        <td>{{ret.BranchName}}</td>
                        <td class="text-right">{{ret.Quantity}}</td>
                        <td class="text-right">{{ret.QuantityIn}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            company: {},
            records: [],
            fromd: '',
            tod: ''
        };
    },
    created() {
        this.fromd = this.$route.query.from;
        this.tod = this.$route.query.to;
        this.getCompany();
        this.toList();
    },
    methods: {
        getCompany: function() {
            this.$api().post("company").then(res => {
                this.company = res.data.Data;
            });
        },
        toList() {
            var loading = this.$loading.show();
            var req = {
                FromDate: this.fromd,
                ToDate: this.tod
            };
            this.$api()
                .post("report/stockout/detail", { request: req })
                .then(res => {
                this.records = res.data.Json.StockOutDetails;
                })
                .finally(() => {
                loading.hide();
                });
        }
    }
};
</script>